module.exports = __webpack_public_path__ + "media/section1Video.7c04e844.mp4";